import { render, staticRenderFns } from "./eventUpdate.vue?vue&type=template&id=a89f9922&scoped=true"
import script from "./eventUpdate.ts?vue&type=script&lang=ts&external"
export * from "./eventUpdate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f9922",
  null
  
)

export default component.exports